// src/stores/useCountyLayerStore.js
//
// Manages county-boundary overlay layer visibility state.
// Consumed by ReferenceTab (toggle UI) and MapView (layer sync effect).
//
// Modeled on useGloStore. Mutual exclusivity with the GLO survey grid is
// enforced in ReferenceTab's toggle handlers, not here — this store is a
// dumb boolean so MapView's visibility effect stays a one-line read.
//
// Default ON: the county grid is the calmer reference framework for the
// MVP — county jurisdiction lines map onto how users think about land.
// The dense GLO survey mesh is opt-in via the Reference tab.

import { create } from "zustand";

export const useCountyLayerStore = create((set) => ({
  countiesVisible: true,
  toggleCounties: () => set((s) => ({ countiesVisible: !s.countiesVisible })),
  setCountiesVisible: (v) => set({ countiesVisible: v }),
}));
